// extracted by mini-css-extract-plugin
export default {"button":"wp_button__Lymbm","icon":"wp_icon__W73pK","text":"wp_text__SPiR1"};